function WhatsNew() {
    return <>
        <div className="container">
            <header className="has-text-centered">
                <h1 className="title">What's New</h1>
            </header>
            <section className="">
                <div className="is-size-6 mt-4">
                    <h2 className="title is-5 mb-3">September 5, 2026</h2>
                    <div className="content">
                        <ul>
                            <li>
                                Initial implementation of Phantom Epoch campaign tracker
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="is-size-6 mt-4">
                    <h2 className="title is-5 mb-3">April 15, 2026</h2>
                    <div className="content">
                        <ul>
                            <li>
                                Stonesage: added Omens to the cave wall
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="is-size-6 mt-4">
                    <h2 className="title is-5 mb-3">April 7, 2026</h2>
                    <div className="content">
                        <ul>
                            <li>
                                Stonesage: added ability to edit and delete Challend Records, Ongoing Goals, and Looming Challenges in an Epoch
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="is-size-6 mt-4">
                    <h2 className="title is-5 mb-3">April 1, 2026</h2>
                    <div className="content">
                        <ul>
                            <li>
                                Stonesage: added Journey and Night card tracking
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="is-size-6 mt-4">
                    <h2 className="title is-5 mb-3">March 23, 2026</h2>
                    <div className="content">
                        <ul>
                            <li>
                                Stonesage: fixed bug with saving
                            </li>
                            <li>
                                Stonesaga: Added "Cave Entries" to Culture page
                            </li>
                            <li>
                                Stonesaga: Edit and Delete ability for Recipes, Experiments and Investigations
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="is-size-6 mt-4">
                    <h2 className="title is-5 mb-3">March 20, 2026</h2>
                    <div className="content">
                        <ul>
                            <li>
                                Stonesaga: added lists for Mantle Powers, Knowledge Cards and Structures
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="is-size-6 mt-4">
                    <h2 className="title is-5 mb-3">March 17, 2026</h2>
                    <div className="content">
                        <ul>
                            <li>
                                Stonesage: added support for Outposts
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="is-size-6 mt-4">
                    <h2 className="title is-5 mb-3">March 16, 2026</h2>
                    <div className="content">
                        <ul>
                            <li>
                                Stonesage: updated Valley Map colors and made improvements to navigation on tablets
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="is-size-6 mt-4">
                    <h2 className="title is-5 mb-2">March 15, 2026</h2>
                    <div className="content">
                        <ul>
                            <li>Stonesage Campaign Tracker Is LIVE!</li>
                        </ul>
                    </div>
                </div>
                <div className="is-size-6 mt-4">
                    <h2 className="title is-5 mb-2">March 22, 2026</h2>
                    <div className="content">
                        <ul>
                            <li>Primal The Awakening: Added Pierce and Rhythym classes.</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    </>
}

export default WhatsNew;